import React, {useState, useEffect, useRef} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { Button } from '../Button';
import { Dialog, DialogTitle, DialogContent } from '../Dialog';
import styles from './BuyNowLite-tw-styles';
import Typography from '../Typography';
import DOMPurify from 'isomorphic-dompurify';
import { useBinLite } from '@procter-gamble/bin-lite-button'

const BuyNowLiteDialog =(props)=> {
  let { open, variant, buyNowData, productShortName,productData } = props;
 const [buyNowDataUpdated, setBuyNowDataUpdated] = useState(null)
 const [selectedVariant, setSelectedVariant]= useState(null)
 
 const dialogRef = useRef(null);
 const closeButtonRef = useRef(null);
 
 const binParams = {
    gtin: selectedVariant ===null && productData && productData !=undefined ? productData.gtin : selectedVariant ,
    passkey: process.env.BUYNOW_LITE_PASSKEY,
    orderby: 'random',
    retailersChoice: 'desired',
    isDevelopment: process.env.PROJECT_ENV.trim() === 'development'
  }
  const prevRetailers=useRef([])
  const { retailers,isLoadingRetailers, fetchRetailers } = useBinLite(binParams)
  if(retailers!==prevRetailers.current){
    prevRetailers.current=retailers
    setBuyNowDataUpdated(prevRetailers.current)
  }
 
 useEffect (() => {
  async function test(){
    await fetchRetailers()
  }
  if(binParams.gtin != null && ((productData && productData !=null) || selectedVariant !=null)){
      test();
  }
 },[open,selectedVariant,buyNowData])

  const onChange = async(field, value) => {
    window.dataLayer.push({
      GAeventAction: 'event_buy_now_choose_product',
      GAeventCategory: 'event_bin_action',
      GAeventLabel: value,
      GAeventNonInteraction: false,
      GAeventValue: 0,
      event: 'customEvent',
    });
    
    buyNowData=[]
    setSelectedVariant(value)
  };

  const changeretailer = () => {
    const { onCloseHandler } = props;
   
    setSelectedVariant(null)
    setBuyNowDataUpdated(null)
    onCloseHandler();
    try{
      if(typeof window !=='undefined'){
        const pathcurr=window.location.pathname
        setSlug(pathcurr)
      }
      
    }catch(err){
        console.log("err",err);
    }
    prevRetailers.current=[]
  };

  // Focus trap for dialog
  useEffect(() => {
    if (open) {
      // Store the actual button element that opened the dialog
      const openButton = document.activeElement;

      // Target the specific buy-now-container div
      let dialogContainer = null;
      const tryFindContainer = () => {
        dialogContainer = document.querySelector('.buy-now-container');
        return dialogContainer !== null;
      };

      // Try to find the container, retry if not found
      if (!tryFindContainer()) {
        const timer = setTimeout(() => {
          tryFindContainer();
        }, 200);
        
        if (!dialogContainer) {
          return () => clearTimeout(timer);
        }
      }

      // Focus close button when dialog opens
      setTimeout(() => {
        const closeBtn = document.querySelector('.buy-now-container button[aria-label*="Fechar"]');
        if (closeBtn) {
          closeBtn.focus();
        }
      }, 150);

      const handleKeyDown = (e) => {
        if (e.key === 'Escape') {
          e.preventDefault();
          changeretailer();
          return;
        }

        if (e.key === 'Tab') {
          const container = document.querySelector('.buy-now-container');
          if (!container) return;

          const visibleFocusable = Array.from(
            container.querySelectorAll(
              'button:not([disabled]), [href]:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]):not([disabled])'
            )
          ).filter(el => {
            const style = getComputedStyle(el);
            return el.offsetParent !== null && 
                   style.display !== 'none' && 
                   style.visibility !== 'hidden' &&
                   !el.hasAttribute('hidden');
          });

          if (visibleFocusable.length === 0) return;

          // Reorder to match visual layout for boundary checks
          const closeButton = visibleFocusable.find(el => el.classList.contains('buy-now-close'));
          const variantSelect = visibleFocusable.find(el => el.tagName === 'SELECT');
          const retailerLinks = visibleFocusable.filter(el => 
            el.tagName === 'A' && el.classList.contains('event_buy_now_eretailer_exit')
          );

          // Visual order for focus trap boundaries
          const focusOrder = [];
          if (closeButton) focusOrder.push(closeButton);
          focusOrder.push(...retailerLinks);
          if (variantSelect) focusOrder.push(variantSelect);

          if (focusOrder.length === 0) return;

          const firstElement = focusOrder[0];
          const lastElement = focusOrder[focusOrder.length - 1];
          const activeElement = document.activeElement;

          if (e.shiftKey) {
            if (activeElement === firstElement) {
              e.preventDefault();
              lastElement.focus();
            }
          } else {
            if (activeElement === lastElement) {
              e.preventDefault();
              firstElement.focus();
            }
          }
        }
      };

      document.addEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'hidden';

      return () => {
        document.removeEventListener('keydown', handleKeyDown);
        document.body.style.overflow = 'unset';
        
        // Restore focus to the button that opened the dialog
        setTimeout(() => {
          if (openButton && 
              openButton.classList && 
              openButton.classList.contains('event_buy_now') &&
              typeof openButton.focus === 'function') {
            openButton.focus();
          }
        }, 150);
      };
    }
  }, [open]);
    
    const i18nMessages = require('../../../constants/messages/pt-BR');

    return (
      <Dialog
        open={open}
        onClose={changeretailer}
        modalStyle={classNames(styles.dialog.mainDiv)}
        role="menu"
        aria-modal="true"
        aria-labelledby="buynow-dialog-title"
        aria-describedby="buynow-dialog-description"
      >
         <img
          className={styles.buyNowLiteLogo}
          src='https://images.ctfassets.net/bwmjeuu0n1om/3sulFLTdVyZR7brV7dFP2d/27976b9b188ff4078f37ea02778bf15d/pantene-logo.png'
          alt="pantene-logo"
        />   
        <DialogTitle id="buynow-dialog-title" className={styles.dialog.title} component="div">
          {buyNowDataUpdated && buyNowDataUpdated.length > 0 ? (
            <FormattedMessage
              id={i18nMessages.chooseRetailer}
              defaultMessage={i18nMessages.chooseRetailer}
            />
          ) : (
            buyNowData &&
            buyNowData.length > 0 && (
              <FormattedMessage
                id={i18nMessages.chooseRetailer}
                defaultMessage={i18nMessages.chooseRetailer}
              />
            )
          )}

          <Button
            ref={closeButtonRef}
            className={styles.dialog.closeButton}
            onClick={changeretailer}
            aria-label="Fechar diálogo"
          >
            <span className={styles.dialog.closeSpan} aria-hidden="true">×</span>
          </Button>
        </DialogTitle>
        <div id="buynow-dialog-description" className="sr-only">
          Selecione o tamanho da variante e escolha um varejista para comprar o produto.
        </div>
        <div className={styles.buyNowLitevarientContainer}>
          <div className={styles.buyNowLiteRetailerWrapper} role="region" aria-label="Varejistas disponíveis">
            <div className={styles.buyNowLiteproductName}>  
              <Typography
                className={styles.buyNowLiteproductName}
                component='div'
                dangerouslySetInnerHTML={{
                      __html:DOMPurify.sanitize(productShortName),
                 }}
              />
            </div>
            <DialogContent className={styles.dialog.content}>
              {buyNowDataUpdated && buyNowDataUpdated?.length > 0 && typeof(buyNowDataUpdated) !='string' && (buyNowDataUpdated !== "Sorry No Result!!!!" || buyNowDataUpdated === null)? (
                buyNowDataUpdated.filter(data => data.BuyNowUrl && data.BuyNowUrl.trim() !== '').length > 0 ? (
                  buyNowDataUpdated.filter(data => data.BuyNowUrl && data.BuyNowUrl.trim() !== '').map(data => {
                    return (
                      <div className={styles.dialog.linkContainer} key={data.RetailerName}>
                        <a
                          data-pgaction-redirection="0"
                          data-action-detail={data.RetailerName}
                          className={styles.dialog.link}
                          href={data.BuyNowUrl}
                          target={i18nMessages.blank}
                          rel={i18nMessages.noopenernoreferrer}
                          aria-label={`Comprar em ${data.RetailerName}`}
                        >
                          <img
                            alt={data.RetailerName}
                            src={`data:image/png;base64,${data.Retailerlogo}`}
                          />
                        </a>
                      </div>
                    );
                  })
                ) : (
                  <div className={styles.buyNowLiteStoreVisit}>
                    <FormattedMessage
                      id={i18nMessages.visitNearStore}
                      defaultMessage={i18nMessages.visitNearStore}
                    />
                  </div>
                )
              )
              : buyNowData && buyNowData.length > 0 && typeof(buyNowData)!='string' && buyNowData !== "Sorry No Result!!!!" && buyNowDataUpdated !== "Sorry No Result!!!!"? (
                buyNowData.filter(data => data.BuyNowUrl && data.BuyNowUrl.trim() !== '').length > 0 ? (
                  buyNowData.filter(data => data.BuyNowUrl && data.BuyNowUrl.trim() !== '').map(data => {
                    return (
                      <div className={styles.dialog.linkContainer} key={data.RetailerName}>
                        <a
                          data-pgaction-redirection="0"
                          data-action-detail={data.RetailerName}
                          className={styles.dialog.link}
                          href={data.BuyNowUrl}
                          target={i18nMessages.blank}
                          rel={i18nMessages.noopenernoreferrer}
                          aria-label={`Comprar em ${data.RetailerName}`}
                        >
                          <img
                            alt={data.RetailerName}
                            src={`data:image/png;base64,${data.Retailerlogo}`}
                          />
                        </a>
                      </div>
                    );
                  })
                ) : (
                  <div className={styles.buyNowLiteStoreVisit}>
                    <FormattedMessage
                      id={i18nMessages.visitNearStore}
                      defaultMessage={i18nMessages.visitNearStore}
                    />
                  </div>
                )
              ) : (
                <div className={styles.buyNowLiteStoreVisit}>
                  <FormattedMessage
                    id={i18nMessages.visitNearStore}
                    defaultMessage={i18nMessages.visitNearStore}
                  />
                </div>
              )}
            </DialogContent>
          </div>
          <div className={styles.buyNowLiteVarientWrapper}>
            <label 
              htmlFor="variant-select" 
              className={styles.buyNowLiteVarientsize}
              id="variant-select-label"
            >
              {i18nMessages.varientSize}
            </label>
            <select
              id="variant-select"
              name="variantSelect"
              aria-labelledby="variant-select-label"
              aria-required="false"
              value={selectedVariant ?? (variant && variant[0] && variant[0].gtin) ?? ''}
              onChange={e => onChange(e.target.name, e.target.value)}
              onKeyDown={e => {
                // Prevent ArrowUp/ArrowDown from changing value unless Alt is pressed (which opens the dropdown in most browsers)
                if ((e.key === 'ArrowUp' || e.key === 'ArrowDown') && !e.altKey && !e.ctrlKey && !e.metaKey) {
                  e.preventDefault();
                  e.stopPropagation();
                }
              }}
            >
              {variant &&
                variant.map((eachVariant) => {
                  const isSelected = (selectedVariant ?? (variant && variant[0] && variant[0].gtin) ?? '') === eachVariant.gtin;
                  return (
                    <option
                      key={eachVariant.gtin}
                      value={eachVariant.gtin}
                      aria-selected={isSelected}
                      {...(isSelected ? { 'aria-label': `${eachVariant.variantName}, selected` } : {})}
                    >
                      {eachVariant.variantName}
                    </option>
                  );
                })}
            </select>
            {/* Polite aria-live region for announcing selection */}
            <span
              aria-live="polite"
              aria-atomic="true"
              style={{ position: 'absolute', left: '-9999px', height: '1px', width: '1px', overflow: 'hidden' }}
            >
              {(() => {
                const selectedVariantObj =
                  variant?.find((v) => v.gtin === selectedVariant) ?? variant?.[0];
                return selectedVariantObj ? `${selectedVariantObj.variantName} selecionado` : '';
              })()}
            </span>
          </div>
        </div>
           <img
          className={styles.buyNowLiteLogoTwo}
          src='https://images.ctfassets.net/bwmjeuu0n1om/2yPjvRcvqy4vTV8Tvjr1z8/2050aac13cda2d211ffe10d2f152ddf7/buy-now-lite-icon.png'
          alt="buy_now_logo"
        />   
      </Dialog>
    );
  }

export default BuyNowLiteDialog;
